export default {
  'aws_project_region': 'us-west-2',
  'aws_cloud_logic_custom': [
    {
      'name': 'creatorai',
      'endpoint': 'https://c2u39tudz0.execute-api.us-west-2.amazonaws.com/baex/bae',
      'region': 'us-west-2',
    },
  ],
  'aws_cognito_identity_pool_id': 'us-west-2:34d14b87-6b9e-4f15-bd50-00a4a89dbec1',
  'aws_cognito_region': 'us-west-2',
  'aws_user_pools_id': 'us-west-2_6UDGH1cBV',
  'aws_user_pools_web_client_id': '7vipuev5gh043lsc0qqome7ob1',
  'oauth': {},
  'aws_cognito_username_attributes': [
    'EMAIL',
  ],
  'aws_cognito_social_providers': [],
  'aws_cognito_signup_attributes': [],
  'aws_cognito_mfa_configuration': 'OFF',
  'aws_cognito_mfa_types': [
    'SMS',
  ],
  'aws_cognito_password_protection_settings': {
    'passwordPolicyMinLength': 8,
    'passwordPolicyCharacters': [
      'REQUIRES_LOWERCASE',
      'REQUIRES_NUMBERS',
      'REQUIRES_SYMBOLS',
      'REQUIRES_UPPERCASE',
    ],
  },
  'aws_cognito_verification_mechanisms': [
    'EMAIL',
  ],
  'aws_content_delivery_bucket': 'ofapp-2024030116494223-hostingbucket-staging',
  'aws_content_delivery_bucket_region': 'us-west-2',
  'aws_content_delivery_url': 'https://d33vots3w8amez.cloudfront.net',
  'aws_user_files_s3_bucket': 'creatorai517af-baex',
  'aws_user_files_s3_bucket_region': 'us-west-2',
} as const
